/**
 * Returns the number of decimals needed based on allocation type
 * @param {string} allocationType
 * @return {number}
 */
export const allocationTypeDecimals = (allocationType) => {
    let decimals;

    switch (allocationType) {
    case 'percentage':
        decimals = 1;
        break;
    case 'price':
        decimals = 2;
        break;
    case 'quantity':
        decimals = 3;
        break;
    default:
        decimals = 1;
        break;
    }

    return decimals;
};

/**
 * Returns the number of decimals needed based on allocation type
 * @param {string} value
 * @param {string} separator ( values comma, point, space)
 * @param {number} minDecimals
 * @return {string}
 */
export const formatCurrencySeparator = (value, separator, minDecimals) => {
    if (!value) return '';
    if (separator === 'comma') {
        return Number(value).toLocaleString('en-US', {minimumFractionDigits: minDecimals});
    } else if (separator === 'point') {
        return Number(value).toLocaleString('de-DE', {minimumFractionDigits: minDecimals});
    } else {
        // this is space
        return Number(value).toLocaleString('fr-FR', {minimumFractionDigits: minDecimals});
    }
};

/**
 * Returns the nunformated number
 * @param {string} inputString
 * @return {string}
 */
export const normalizeDecimalSeparator = (inputString) => {
    // Determine the decimal separator used in the string
    if (!inputString) return '';
    const cleanStr = inputString.replace(/\d/g, '');
    const patternDot = /^[.]+$/;
    const patternComma = /^[,]+$/;
    if ( (patternDot.test(cleanStr) || patternComma.test(cleanStr)) && cleanStr.length > 1) {
        return inputString.replace(/[.,]/g, '');
    } else {
        // check what's the last element of the string and treat it as a decimal separator
        if ( cleanStr.length === 1) {
        // let's check how many digits do we have on the right side , if it's bigger then 2 then we will treat it as a thousand separator
            const splitedTxt = inputString.split(cleanStr);
            if ( splitedTxt?.[1]?.length > 2) {
                if ( cleanStr === '.') {
                    // we asume it's a decimal separator
                    return inputString.replace(/,/g, '');
                } else {
                    // we asume it's a thousand separator
                    return inputString.replace(/\./g, '').replace(/,/g, '');
                }
            } else {
                const lastElemInStr = cleanStr.charAt(cleanStr.length -1);
                if ( lastElemInStr === '.') {
                    return inputString.replace(/,/g, '');
                } else {
                    return inputString.replace(/\./g, '').replace(/,/g, '.');
                }
            }
        } else {
            const lastElemInStr = cleanStr.charAt(cleanStr.length -1);
            if ( lastElemInStr === '.') {
                return inputString.replace(/,/g, '');
            } else {
                return inputString.replace(/\./g, '').replace(/,/g, '.');
            }
        }
    }
};
